import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { apiCallBegan } from "./api";
import { useNavigate } from "react-router-dom";

const slice = createSlice({
  name: "broker",
  initialState: {
    isTwoFARequired: false,
    istokenvalid: false,
    verifyingtoken: false,
    information: null,
    verifyingCredentials: false,
    varifyCode: false,
    code: [],
    loginAttemptSuccess: null,
    jwt: null,
    isadmin: false,
    issuperadmin: false,
    userRoles: [],
    province: [],
    brokrageData: [],
    insurerListCodes: [],
    brokerageImg: false,
    clientView: false,
    twoFactorVerified: null,
    resendMessageSuccess: null,
    twoFAverificationFailedMessage: null,
    isTwofactorVerified: false,
    verifiedErrorMessage: null,
    isBrokerSuccess: "",
    isUserVerified: false,
    languagepreference: "en",
    updatedProfile: false,
    refetchInsurerList: false,
    activities: []
  },
  reducers: {
    // action => action handler

    verificationInitialized: (broker, action) => {
      broker.istokenvalid = false;
      broker.verifyingtoken = true;
    },
    brokerVerified: (broker, action) => {
      console.log("BROKER VERIFIED");
      console.log(action.payload)
      broker.istokenvalid = true;
      broker.information = action.payload;
      broker.verifyingtoken = false;
      broker.updatedProfile = false;
      broker.isadmin = isBrokerAdmin(broker);
      broker.issuperadmin = isBrokerSuperAdmin(broker);
      broker.loginAttemptSuccess = true;
      if(action.payload?.languagepreference){
        broker.languagepreference = action.payload.languagepreference;
      }
    },
    activitiesVerified: (broker, action) => {
      broker.activities = action.payload;
    },
    brokerVerificationFailed: (broker, action) => {
      broker.istokenvalid = false;
      // broker.information = null;
      broker.verifyingtoken = false;
    },

    brokerLoginRequested: (broker, action) => {
      broker.verifyingCredentials = true;
    },
    twoFAverificationSuccess: (broker, action) => {
      broker.twoFactorVerified = action.payload.message;
      broker.jwt = action.payload.token;
      broker.isTwofactorVerified = false;
    },
    twoFAverificationFailed: (broker, action) => {
      broker.twoFAverificationFailedMessage = action.payload;
    },
    resendCodeSuccess: (broker, action) => {
      broker.resendMessageSuccess = action.payload.message;
    },
    getBrokerInsurerListSuccess: (broker, action) => {
      broker.insurerListCodes = action.payload;
      broker.refetchInsurerList = false;
    },
    updatedBrokerInsurerListSuccess: (broker, action) => {
      broker.refetchInsurerList = true;
    },
    updateBrokerLanguagePreference: (broker, action) => {
      const newLanguage = action.payload;
      console.log('Attempting to update language preference to:', newLanguage); 
    
      if(!newLanguage){
        return;
      }
      
      if (!broker) {
        console.error('Broker object is null or undefined in the state. Cannot update language preference.');
        return; 
      }
  
      console.log('Updating broker.languagepreference');
      broker.languagepreference = newLanguage;
    
      if (broker.information) {
        console.log('Updating broker.information.languagepreference');
        broker.information.languagepreference = newLanguage;
      } else {
        console.log('Creating broker.information object.');
        broker.information = { languagepreference: newLanguage };
      }
    },

    updateBrokerProfileInitialized: (broker, action) => {
      broker.updatedProfile = false;
    },
    updateBrokerProfileRequested: (broker, action) => {
      broker.updatedProfile = true;
    },
    existingBrokrageRequested: (broker, action) => {
      broker.varifyCode = true;
    },
    brokerLoginFailed: (broker, action) => {
      broker.verifyingCredentials = false;
      broker.jwt = null;
      broker.loginAttemptSuccess = false;
    },
    existingBrokrageFailed: (broker, action) => {
      broker.varifyCode = false;
      broker.code = action.payload ? action.payload : [];
    },
    brokerLoggedIn: (broker, action) => {
      
      broker.isBrokerSuccess = "loginSuccess";
      broker.verifyingCredentials = false;
      localStorage.setItem("jwt", action.payload.token);
      broker.jwt = action.payload.token;
      broker.isTwoFARequired = action.payload.twoFARequired;
      broker.loginAttemptSuccess = true;
     
    },
    existingBrokrageSuccess: (broker, action) => {
      broker.code = action.payload ? action.payload : [];
    },
    existingBrokrageImgSuccess: (broker, action) => {
      broker.brokerageImg = action.payload ? action.payload : [];
    },
    existingBrokerSuccess: (broker, action) => {
      broker.clientView = action.payload;
    },
    addNewBrokrageSuccess: (broker, action) => {
      broker.brokrageData = action.payload ? action.payload : [];
    },
    brokerLoggedOut: (broker, action) => {
      broker.information = null;
      broker.istokenvalid = false;
      broker.jwt = null;
      broker.loginAttemptSuccess = null;
      broker.verifyingCredentials = false;
      broker.verifyingtoken = false;
      broker.isUserVerified = false;
    },
    provinceSuccess: (broker, action) => {
      broker.province = action.payload ? action.payload : [];
    },

    userRolesRetrieved: (broker, action) => {
      broker.userRoles = action.payload ? action.payload.roles : [];
      broker.isadmin = isBrokerAdmin(broker);
      broker.issuperadmin = isBrokerSuperAdmin(broker);
      broker.isTwofactorVerified = false;
      broker.verifiedErrorMessage = null;
      broker.isUserVerified = true;
    },
    userRolesFailed: (broker, action) => {
      broker.isTwofactorVerified = true;
      broker.verifiedErrorMessage = action.payload;
    },
  },
});

export const {
  twoFAverificationSuccess,
  twoFAverificationFailed,
  resendCodeSuccess,
  getBrokerInsurerListSuccess,
  updatedBrokerInsurerListSuccess,
  updateBrokerLanguagePreference,
  updateBrokerProfileRequested,
  updateBrokerProfileInitialized,
  brokerVerified,
  activitiesVerified,
  verificationInitialized,
  brokerVerificationFailed,
  brokerLoginRequested,
  existingBrokrageRequested,
  existingBrokrageImgRequested,
  existingBrokrageFailed,
  existingBrokrageImgFailed,
  brokerLoginFailed,
  brokerLoggedIn,
  existingBrokrageSuccess,
  existingBrokerSuccess,
  existingBrokrageImgSuccess,
  addNewBrokrageSuccess,
  brokerLoggedOut,
  userRolesRetrieved,
  userRolesFailed,
  provinceSuccess,
} = slice.actions;

export default slice.reducer;

// Action Creators

export const verifyToken = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers/me",
    method: "get",
    onStart: verificationInitialized.type,
    onSuccess: brokerVerified.type,
    onError: brokerVerificationFailed.type,
  });

export const getBrokerStats = () => 
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers/activities",
    method: "get",
    // onStart: verificationInitialized.type,
    onSuccess: activitiesVerified.type,
    // onError: brokerVerificationFailed.type,
  });

export const twoFAVerification = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/auth/verify-two-fa",
    method: "post",
    data: data,
    onSuccess: twoFAverificationSuccess.type,
    onError: twoFAverificationFailed.type,
  });

export const getBrokeragesBrokers = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/getBrokeragesBrokers",
    method: "post",
    data: data,
    onSuccess: twoFAverificationSuccess.type,
  });

export const getInsurerCreds = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers/getInsurerCreds",
    method: "post",
    data: data,
    onSuccess: getBrokerInsurerListSuccess.type,
  });

export const updateInsurerCreds = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers/updateInsurerCreds",
    method: "post",
    data: data,
    onSuccess: updatedBrokerInsurerListSuccess.type,
  });

export const updateBrokerProfile = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers/myprofile/edit",
    method: "post",
    data: data,
    onStart: updateBrokerProfileInitialized.type,
    onSuccess: updateBrokerProfileRequested.type,
  });

export const resendCodeVerification = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/auth/resend-two-fa-mail",
    method: "get",
    onSuccess: resendCodeSuccess.type,
  });

export const loginBroker = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/auth",
    method: "post",
    data: data,
    onStart: brokerLoginRequested.type,
    onSuccess: brokerLoggedIn.type,
    onError: brokerLoginFailed.type,
  });

  export const loginBrokerWithSSO = (data) => {
    return apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/auth/authenticate",
      method: "post",
      data,
      onStart: brokerLoginRequested.type,
      onSuccess: brokerLoggedIn.type,
      onError: brokerLoginFailed.type,
    });
  };

export const existingBrokrage = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/get-exitsting-brokerage",
    method: "post",
    data: data,
    onStart: existingBrokrageRequested.type,
    onSuccess: existingBrokrageSuccess.type,
    onError: existingBrokrageFailed.type,
  });

export const retrieveBrokerforClient = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokers/get-info/" + data,
    method: "get",
    onSuccess: existingBrokerSuccess.type,
  });
export const retrieveBrokerageImg = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/get-info/" + data,
    method: "get",
    onSuccess: existingBrokrageImgSuccess.type,
  });

export const addNewBrokerage = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/brokerages/signup-now",
    method: "post",
    data: data,
    // onStart: existingBrokrageRequested.type,
    onSuccess: addNewBrokrageSuccess.type,
    // onError: existingBrokrageFailed.type,
  });
export const getUserRoles = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/users/me",
    method: "get",
    onSuccess: userRolesRetrieved.type,
    onError: userRolesFailed.type,
  });
export const getProvinces = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/common/provinces",
    method: "get",
    onSuccess: provinceSuccess.type,
  });
export const isBrokerAdmin = (broker) => {
  try {
    return broker.userRoles.includes("broker_admin");
  } catch (err) {
    return false;
  }
};

export const isBrokerSuperAdmin = (broker) => {
  try {
    return broker.userRoles.includes("broker_superadmin");
  } catch (err) {
    return false;
  }
};

// Selector

export const getBrokerInformation = createSelector(
  (state) => state.entities.broker,
  (broker) => broker
);
export const isSignupResponse = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.brokrageData
);
export const getProvinceInformation = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.province
);

export const isBrokerBeingVerified = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.verifyingCredentials
);

export const getJWT = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.jwt
);

export const getUpdatedProfile = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.updatedProfile
);

export const getLoginAttemptSuccess = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.loginAttemptSuccess
);
export const getExistingBrokerage = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.code
);
export const getBrokerInsurerList = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.insurerListCodes
);

export const getRefetchInsurerList = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.refetchInsurerList
);

export const existingBrokrageInitialize = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.varifyCode
);
export const getIsTokenValid = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.istokenvalid
);

export const getVerifyingToken = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.verifyingtoken
);

export const getBrokerFirstName = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.information.firstname
);
export const getIsTwoFARequired = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.isTwoFARequired
);
export const getTwoFactorVerified = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.twoFactorVerified
);
export const resendVerificationMessage = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.resendMessageSuccess
);
export const getTwofactorVerifiedKey = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.isTwofactorVerified
);
export const getVerifiedErrorMessage = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.verifiedErrorMessage
);
export const getBrokerSuccess = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.isBrokerSuccess
);
export const getTwoFAVerificationFailedMessage = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.twoFAverificationFailedMessage
);
export const getIsUserVerified = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.isUserVerified
);

export const getLanguagePreference = createSelector(
  (state) => state.entities.broker,
  (broker) => broker.languagepreference
);
